// Reconstructed from the supplied production build; original component names were unavailable.
import {
  CircleCheckBigIcon,
  ClockIcon,
  React,
  RefreshCwIcon,
  SaveIcon,
  TriangleAlertIcon,
  jsxRuntime,
} from "../vendor/runtime.js";
import { api } from "../services/api.js";
const ProductAnalysisDetailsForm = ({ product: e = {}, onUpdate: t }) => {
  const [n, r] = React.useState((e == null ? undefined : e.analysis_status) || "pending"),
    [a, l] = React.useState((e == null ? undefined : e.analysis_results) || ""),
    [c, d] = React.useState(false),
    [f, h] = React.useState(null),
    [p, g] = React.useState(false),
    y = [
      {
        value: "pending",
        label: "Pending",
        icon: ClockIcon,
        color: "text-yellow-500",
      },
      {
        value: "not",
        label: "In Progress",
        icon: RefreshCwIcon,
        color: "text-purple-700",
      },
      {
        value: "completed",
        label: "Completed",
        icon: CircleCheckBigIcon,
        color: "text-green-500",
      },
      {
        value: "failed",
        label: "Failed",
        icon: TriangleAlertIcon,
        color: "text-red-500",
      },
    ],
    v = (b) => {
      (r(b), g(false));
    },
    j = (b) => {
      (l(b.target.value), g(false));
    },
    N = async () => {
      if (!e || !e.id) {
        h("Invalid product: Missing product ID");
        return;
      }
      (d(true), h(null), g(false));
      try {
        const b = await api.put(`/admin/products/${e.id}/analysis`, {
          analysis_status: n,
          analysis_results: a,
        });
        (g(true), t && typeof t == "function" && t(b.data));
      } catch (b) {
        (console.error("Error updating analysis status:", b),
          h("Failed to update analysis status. Please try again."));
      } finally {
        d(false);
      }
    };
  return !e || typeof e != "object" ? (
    <div className={"bg-white rounded-xl shadow-sm p-6"}>
      <div className={"flex items-center space-x-3 text-yellow-500"}>
        <TriangleAlertIcon className={"h-5 w-5"} />
        <p className={"text-sm font-medium"}>
          {"No valid product data available for analysis. Please select a product first."}
        </p>
      </div>
    </div>
  ) : (
    <div className={"space-y-4"}>
      {f && (
        <div className={"mb-4 bg-red-50 border-l-4 border-red-400 p-4 rounded-md"} role={"alert"}>
          <div className={"flex"}>
            <div className={"flex-shrink-0"}>
              <TriangleAlertIcon className={"h-5 w-5 text-red-400"} />
            </div>
            <div className={"ml-3"}>
              <p className={"text-sm text-red-700"}>{f}</p>
            </div>
          </div>
        </div>
      )}
      {p && (
        <div
          className={"mb-4 bg-green-50 border-l-4 border-green-400 p-4 rounded-md"}
          role={"alert"}
        >
          <div className={"flex"}>
            <div className={"flex-shrink-0"}>
              <CircleCheckBigIcon className={"h-5 w-5 text-green-400"} />
            </div>
            <div className={"ml-3"}>
              <p className={"text-sm text-green-700"}>{"Analysis status updated successfully!"}</p>
            </div>
          </div>
        </div>
      )}
      <div className={"space-y-4"}>
        <div>
          <label className={"block text-sm font-medium text-gray-700 mb-1"}>
            {"Analysis Status"}
          </label>
          <div className={"grid grid-cols-2 gap-3"}>
            {y.map((b) => (
              <button
                key={b.value}
                type={"button"}
                onClick={() => v(b.value)}
                className={`flex items-center px-4 py-3 rounded-lg border ${n === b.value ? "bg-purple-50 border-purple-300 ring-2 ring-purple-200" : "border-gray-200 hover:bg-gray-50"}`}
              >
                <b.icon className={`h-5 w-5 mr-2 ${b.color}`} />
                <span className={"text-gray-900 font-medium"}>{b.label}</span>
              </button>
            ))}
          </div>
        </div>
        <div>
          <label
            htmlFor={"analysis-results"}
            className={"block text-sm font-medium text-gray-700 mb-1"}
          >
            {"Analysis Results / Notes"}
          </label>
          <textarea
            id={"analysis-results"}
            rows={"4"}
            className={
              "w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-purple-500 focus:border-purple-500"
            }
            placeholder={"Enter any analysis results or notes..."}
            value={a}
            onChange={j}
          />
        </div>
        <div className={"flex justify-end"}>
          <button
            type={"button"}
            className={
              "px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 flex items-center"
            }
            onClick={N}
            disabled={c}
          >
            {c ? (
              <jsxRuntime.Fragment>
                <RefreshCwIcon className={"h-5 w-5 mr-2 animate-spin"} />
                {"Updating..."}
              </jsxRuntime.Fragment>
            ) : (
              <jsxRuntime.Fragment>
                <SaveIcon className={"h-5 w-5 mr-2"} />
                {"Update Status"}
              </jsxRuntime.Fragment>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};
export { ProductAnalysisDetailsForm };
